import React, { useEffect, useState } from 'react'

export default function Button_check({Checked,setChecked}) {
  return (
    <button className={`btn-check ${Checked ? 'check' : ''}`} onClick={_ => Checked ? setChecked(false) : setChecked(true)}></button>
  )
}
